import { Component, inject, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ShellDataService, UserDataStateService, UserTypeStateService } from '@ribera-web/auth-data-acess';

@Component({
  imports: [RouterModule],
  selector: 'app-root',
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App implements OnInit {
  protected title = 'ribera-web';

  private userState = inject(UserDataStateService);
  
  ngOnInit() {

    this.userState.loadContextApp();
    this.userState.loadDataUser();
    
  }
}
